import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "size", "withBorders"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { ImageCard, InfoCard } from '@beef/smart-kit';
import { withAnalyticsCard } from "../../hocs";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var _CommonCard = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'imageCard' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    withBorders = _ref.withBorders,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('card', _defineProperty({}, "card__image--".concat(size), type === 'imageCard')),
    ref: ref,
    "data-t-id": "components-LayoutCard"
  }, type === 'imageCard' && /*#__PURE__*/React.createElement(ImageCard, _extends({
    bordered: withBorders
  }, props, {
    size: size
  })), type === 'infoCard' && /*#__PURE__*/React.createElement(InfoCard, _extends({
    bordered: withBorders
  }, props)));
});
export var CommonCard = withAnalyticsCard(_CommonCard);